import React from 'react';
import styled from 'styled-components';

const SectionEl = styled.section`
  padding: 4em 1em;
  width: 100%;

  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;
    padding: 5em 2em;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 24px;
  text-align: center;
  @media (min-width: 768px) {
    min-width: 300px;
    max-width: 300px;
    text-align: left;
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  padding-left: 2rem;
  width: calc(100% - 300px);

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    padding-left: 0;
    width: 100%;
  }

  p {
    margin-top: 0;
  }
`;

const Title = styled.h1`
  font-size: 26px;
  margin: 0;
  width: 300px;

  ${({ ellipsis }) =>
    ellipsis &&
    `
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`;

export default function VendorProfileSection({ title, children, ...props }) {
  return (
    <SectionEl>
      <TitleWrapper>
        <Title {...props}>{title}</Title>
      </TitleWrapper>
      <ContentWrapper>{children}</ContentWrapper>
    </SectionEl>
  );
}

export const Section = SectionEl;
